import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Box,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Tooltip,
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import CommonButton from "components/commonButton/CommonButton";
import { truncateComment } from "utils/utils";

export default function EmployeeMultiForm(props) {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
    clearErrors,
    reset,
  } = useForm({ defaultValues: props?.defaultValues, mode: "onChange" });

  const [formError, setFormError] = useState([]);
  const [selectValues, setSelectValues] = useState({});
  const [formData, setFormData] = useState({});

  // ---Country Code---
  const [country, setCountry] = useState("+91");

  //Handling useEffect for adding form data - props.formData change hone par update ho
  useEffect(() => {
    if (props?.formData) {
      setFormData(props?.formData);
    }
  }, [props?.formData]);

  //Handling useEffect for updating default values
  useEffect(() => {
    if (props.defaultValues) {
      setSelectValues(props.defaultValues);

      if (props?.resetForm) {
        reset(props.defaultValues);
      }
      setTimeout(() => {
        console.log(getValues());
      }, 0);
    }
  }, [props.defaultValues]);

  useEffect(() => {
    setCountry(props?.defaultValues?.countryCode || "+91");
  }, [props?.defaultValues?.countryCode]);

  const handleInput = (e, name, fieldValue) => {
    const fieldName = name || e.target.name;
    clearErrors(fieldName);

    setValue(name || e.target.name, fieldValue ?? e.target.value);
    setFormError((prev) => ({
      ...prev,
      [fieldName]: undefined,
    }));
  };

  const handleChange = (event) => {
    setCountry(event.target.value);
  };

  const numberInputOnWheelPreventChange = (e) => {
    e.target.blur();
    e.stopPropagation();
  };

  const handelNegativeInput = (event) => {
    if (!event.target.validity.valid) {
      setValue(event?.target.name, "");
    }
  };

  const dummyFunctiom = (e) => {
    return;
  };

  const onSubmit = (data) => {
    props.onSubmittBtn(data, country);
  };

  const handleDisable = (fieldDisabled, propsDisabled) => {
    return fieldDisabled || propsDisabled || false;
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {formData &&
          Object.keys(formData).map((val, index) => (
            <Box className="multiform-component mt20" key={index}>
              <Grid
                container
                spacing={{ md: 2 }}
                columns={{ xs: 1, sm: 3, md: 12 }}
              >
                {formData[val].map((ele, idx) => {
                  if (!ele) return null;
                  return (
                    <Grid item xs={12} sm={ele.gridSize} key={idx}>
                      <Box display={"grid"} key={ele?.name} className="mb10">
                        <FormControl variant="standard">
                          {ele?.label && (
                            <Typography
                              variant="body2"
                              className="fw600 colorBlack mb10"
                            >
                              {ele?.label}
                              {ele?.required && (
                                <span className="colorRed">
                                  {ele?.star || "*"}
                                </span>
                              )}
                            </Typography>
                          )}
                          <Box
                            className="flexDisplay"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              width: "100%",
                            }}
                          >
                            {/* Country Code */}
                            {ele?.countrycode && (
                              <Box className="customCountryCode">
                                <FormControl>
                                  <Select
                                    disabled={handleDisable(
                                      ele?.fieldDisabled,
                                      props?.disabled,
                                    )}
                                    sx={{
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#E0E0E0",
                                      },

                                      "&.Mui-disabled": {
                                        backgroundColor: "#F5F5F5",
                                      },

                                      "&.Mui-disabled .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "#E0E0E0",
                                        },

                                      "& .MuiSelect-select.Mui-disabled": {
                                        WebkitTextFillColor: "rgba(0,0,0,0.38)",
                                        color: "rgba(0,0,0,0.38)",
                                      },
                                    }}
                                    IconComponent={(params) => (
                                      <ExpandMoreRoundedIcon
                                        className="mr10"
                                        {...params}
                                      />
                                    )}
                                    value={country}
                                    onChange={handleChange}
                                    inputProps={{
                                      "aria-label": "Without label",
                                    }}
                                    className="br10"
                                    name="countryCode"
                                  >
                                    {props?.countryCodeListData &&
                                    props?.countryCodeListData?.length > 0 ? (
                                      props?.countryCodeListData?.map((c) => (
                                        <MenuItem
                                          className="colorBlack"
                                          value={c?.value}
                                          key={c?.value}
                                        >
                                          {c?.label + " " + c?.value}
                                        </MenuItem>
                                      ))
                                    ) : (
                                      <MenuItem
                                        className="colorBlack"
                                        value={country}
                                        key={country}
                                      >
                                        {country}
                                      </MenuItem>
                                    )}
                                  </Select>
                                </FormControl>
                              </Box>
                            )}

                            <FormControl
                              fullWidth
                              className="commonFormControl"
                            >
                              {/* --- Select/Options Field --- */}
                              {ele?.options ? (
                                <Box className="customSelectOption">
                                  <Controller
                                    name={ele?.name}
                                    control={control}
                                    rules={{ required: ele?.required || false }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        value={field.value ?? ""}
                                        IconComponent={(params) => (
                                          <ExpandMoreRoundedIcon
                                            className="mr10"
                                            {...params}
                                          />
                                        )}
                                        disabled={handleDisable(
                                          ele?.fieldDisabled,
                                          props?.disabled,
                                        )}
                                        sx={{
                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#E0E0E0",
                                            },

                                          "&.Mui-disabled": {
                                            backgroundColor: "#F5F5F5",
                                          },

                                          "&.Mui-disabled .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#E0E0E0",
                                            },

                                          "& .MuiSelect-select.Mui-disabled": {
                                            WebkitTextFillColor:
                                              "rgba(0,0,0,0.38)",
                                            color: "rgba(0,0,0,0.38)",
                                          },
                                        }}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          handleInput(
                                            e,
                                            ele?.name,
                                            e.target.value,
                                          );
                                        }}
                                        displayEmpty
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                      >
                                        <MenuItem value="" disabled>
                                          {ele?.placeholder}
                                        </MenuItem>

                                        {ele?.menuOptions?.map(
                                          (option, idx) => (
                                            <MenuItem
                                              key={idx}
                                              value={option?.value}
                                            >
                                              {ele?.name === "branchName" ? (
                                                <Tooltip
                                                  title={option?.label}
                                                  placement="bottom"
                                                >
                                                  <span>
                                                    {truncateComment(
                                                      option?.label,
                                                      40,
                                                    )}
                                                  </span>
                                                </Tooltip>
                                              ) : (
                                                option?.label
                                              )}
                                            </MenuItem>
                                          ),
                                        )}
                                      </Select>
                                    )}
                                  />
                                </Box>
                              ) : ele?.radio ? (
                                /* --- Radio Field --- */
                                <FormControl>
                                  <Controller
                                    name={ele?.name}
                                    control={control}
                                    rules={{ required: ele?.required }}
                                    render={({ field }) => (
                                      <RadioGroup
                                        row
                                        {...field}
                                        value={
                                          field.value ??
                                          selectValues?.[ele?.name] ??
                                          ""
                                        }
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          handleInput(
                                            e,
                                            ele?.name,
                                            e.target.value,
                                          );
                                        }}
                                      >
                                        {ele?.values.map((value) => (
                                          <FormControlLabel
                                            key={value.label}
                                            value={value.value || ""}
                                            control={
                                              <Radio
                                                disabled={handleDisable(
                                                  ele?.fieldDisabled,
                                                  props?.disabled,
                                                )}
                                              />
                                            }
                                            label={value.label}
                                          />
                                        ))}
                                      </RadioGroup>
                                    )}
                                  />
                                </FormControl>
                              ) : ele?.textField ? (
                                /* --- Text Field --- */
                                <Box
                                  sx={{ flex: 1 }}
                                  className="customTextField"
                                >
                                  <TextField
                                    placeholder={ele?.placeholder}
                                    {...register(ele?.name, {
                                      required: ele?.required || false,
                                    })}
                                    type={ele?.type}
                                    error={!!errors[ele?.name]}
                                    onChange={(e) => handleInput(e)}
                                    disabled={handleDisable(
                                      ele?.fieldDisabled,
                                      props?.disabled,
                                    )}
                                    sx={{
                                      "& .MuiInputBase-input.Mui-disabled": {
                                        WebkitTextFillColor:
                                          "rgba(0,0,0,0.38) !important",
                                        color: "rgba(0,0,0,0.38) !important",
                                      },
                                      "& .MuiOutlinedInput-root.Mui-disabled": {
                                        backgroundColor: "#f5f5f5",
                                      },
                                    }}
                                    onWheel={numberInputOnWheelPreventChange}
                                    InputProps={{
                                      inputProps: {
                                        min: ele?.type === "number" ? 1 : "",
                                      },
                                      onInput:
                                        ele?.type === "number"
                                          ? handelNegativeInput
                                          : dummyFunctiom,
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.which === 38 || e.which === 40) {
                                        e.preventDefault();
                                        return;
                                      }
                                    }}
                                  />
                                </Box>
                              ) : (
                                ""
                              )}
                            </FormControl>
                          </Box>

                          {errors[ele?.name] && (
                            <Typography
                              variant={"body2"}
                              className="errorMessage"
                            >
                              {errors[ele?.name]?.message ||
                                "This field is required"}
                            </Typography>
                          )}
                          {formError[ele?.name] && (
                            <div className="errorMessage">
                              {formError[ele?.name]}
                            </div>
                          )}
                        </FormControl>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          ))}

        {props?.button && (
          <Box className="mb20">
            <CommonButton name={props?.button} type="submit" />
          </Box>
        )}
      </form>
    </div>
  );
}
